import { border } from "@smartsheet/design-tokens";
import { createFocusRingStyles } from "../../../util/createFocusRingStyles";
import { themed } from "../../../util/theme";
import { BaseButtonStyledProps } from "../types";

const focusRingTheme = themed({
    borderRadius: {
        "lodestar-light": border.radius10,
        "ursa-light": border.radius20,
    },
    offset: {
        "lodestar-light": 2,
        "ursa-light": 1,
    },
});

export const getButtonFocusRingStyles = ({ themeMode }: BaseButtonStyledProps): string => {
    return createFocusRingStyles({
        gap: focusRingTheme.offset(themeMode),
        componentBorderWidth: 1,
        componentRadius: focusRingTheme.borderRadius(themeMode),
        theme: themeMode,
    });
};
